import { commonFilter } from './filter';

export default {
  pageName: 'feedsNewsMedia',
  pageId: '20004',
  pagePath: '/opinion/newsMedia',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    GPT_Get_Btn: {
      buttonId: '2000401',
    },
    GPT_Confirm: {
      buttonId: '2000402',
    },
    ...commonFilter,
  },
};
